export const summary = state => state.summary;
export const showSummary = state => state.showSummary;
export const weeklySchedule = state => state.weeklySchedule;
export const showWeeklySchedule = state => state.showWeeklySchedule;
export const billingChart = state => state.billingChart;
export const showBillingChart = state => state.showBillingChart;
export const averageTicket = state => state.averageTicket;
export const showAverageTicket = state => state.showAverageTicket;
export const paymentKind = state => state.paymentKind;
export const showPaymentKind = state => state.showPaymentKind;
export const loadingData = state => state.loadingData;
export const brandChart = state => state.brandChart;
export const showBrandChart = state => state.showBrandChart;

export const chartsBeginDate = state => state.chartsBeginDate;
export const chartsEndDate = state => state.chartsEndDate;
export const updateCharts = state => state.updateCharts;
export const chartScope = state => state.chartScope;

export const wallet = state => state.wallet;
export const isLoading = state => state.isLoading;
